import React from 'react';
import { PropTypes } from 'prop-types';
import SelectFancy from '@atoms/SelectFancy';

const getMonthOptions = () => [
    { label: 'January', value: '01' },
    { label: 'Feburary', value: '02' },
    { label: 'March', value: '03' },
    { label: 'April', value: '04' },
    { label: 'May', value: '05' },
    { label: 'June', value: '06' },
    { label: 'July', value: '07' },
    { label: 'August', value: '08' },
    { label: 'September', value: '09' },
    { label: 'October', value: '10' },
    { label: 'November', value: '11' },
    { label: 'December', value: '12' },
];

const SelectMonth = ({
    displayAsNumber,
    hideLabel,
    id,
    isDisabled,
    placeholder = '-- Select --',
    name,
    label = 'Month',
}) => {
    const options = getMonthOptions();

    if (displayAsNumber) {
        options.forEach(option => {
            option.label = option.value;
        });
    }

    return (
        <SelectFancy
            hideLabel={hideLabel}
            isDisabled={isDisabled}
            id={id}
            label={label}
            name={name}
            options={options}
            placeholder={placeholder}
        />
    );
};

SelectMonth.propTypes = {
    displayAsNumber: PropTypes.bool,
    hideLabel: PropTypes.bool,
    id: PropTypes.string,
    isDisabled: PropTypes.bool,
    placeholder: PropTypes.string,
    name: PropTypes.string,
    label: PropTypes.string,
};

export default SelectMonth;
